module.exports = __webpack_public_path__ + "static/media/icon-3w.9079707c.svg";